// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5443":"ad7f724d","6350":"72a30a16"}[chunkId] || chunkId) + "." + {"1896":"3e9b597adadeac87","5443":"93b2e2af59bf3304","6350":"3fc769684ae9224b","7482":"3dfc85e5bae001a9"}[chunkId] + ".js";
};